import { Box, Button, Modal } from "@mui/material";
import React from "react";
import "./ConfirmationModal.css";
import { PROJECT_TYPE } from "../../../../../constants/constant";
import softIconTrash from "../../../../../assets/images/trash.svg";
import archiveIcon from "../../../../../assets/images/archive.svg";
import IoClose from "../../../../../assets/images/IoClose.svg";

const ConfirmationModal = ({
  confirmationTitle,
  confirmationDescription,
  openConfirmation = false,
  setOpenConfirmation,
  onConfirm,
  activeTab,
}) => (
  <Modal
    open={openConfirmation}
    onClose={() => setOpenConfirmation(false)}
    //   aria-labelledby="modal-modal-title"
    //   aria-describedby="modal-modal-description"
  >
    <Box className="ConfirmationModal">
      <Button
        className="closeModalBtn"
        onClick={() => setOpenConfirmation(false)}
      >
        <img className="closeIcon" src={IoClose} alt="close" />
      </Button>
      <center className="p-4">
        {}
        <img
          style={{
            height: "auto",
            width: "auto",
          }}
          src={
            activeTab === PROJECT_TYPE.ARCHIVED ? softIconTrash : archiveIcon
          }
          alt={
            activeTab === PROJECT_TYPE.ARCHIVED ? "Soft Deleted" : "Archived"
          }
        />
        <h4>{confirmationTitle}</h4>
        <p>{confirmationDescription}</p>
        <div className="w-100 ">
          <Button
            className="btnPrimary w-100"
            onClick={onConfirm}
            variant="contained"
            color="primary"
            disableRipple
          >
            Yes, confirm
          </Button>
        </div>
        <div className="w-100 mt-3">
          <Button
            className="cancelBtn w-100"
            variant="outlined"
            color="primary"
            onClick={() => setOpenConfirmation(false)}
            disableRipple
          >
            No, cancel
          </Button>
        </div>
      </center>
    </Box>
  </Modal>
);

export default ConfirmationModal;
